'use strict';

const moment = require('moment');

module.exports = ['$scope', '$timeout', '$location', 'locker', 'ForecastSvc', 'UrlWatcherService', 'MaterialSvc', function ($scope, $timeout, $location, locker, ForecastSvc, UrlWatcherService, MaterialSvc) {
    //-------------
    // General Fns
    //-------------

    function checkAmount(amount) {
        return angular.isDefined(amount) && amount !== null;
    }

    // Normalize the dates so that they starts and ends on a full period length.
    function normalizeDates(sourceFromDate, sourceToDate) {

        if (!sourceFromDate || !sourceToDate) {
            return;
        }

        let fromDate = moment(sourceFromDate, $scope.$root.dateFormat.moment_url);
        let toDate = moment(sourceToDate, $scope.$root.dateFormat.moment_url);

        // Normalize the dates so that they starts and ends on a full period length.
        if ($scope.reportOptions.resolution === 'week') {
            fromDate.day(0);
            toDate.day(6);
        } else if ($scope.reportOptions.resolution === 'month') {
            fromDate.date(1);
            toDate.date(1).add(1, 'months').subtract(1, 'days');
        }

        let fromDateString = fromDate.format($scope.$root.dateFormat.moment_url);
        let toDateString = toDate.format($scope.$root.dateFormat.moment_url);

        return {
            fromDate: fromDateString,
            toDate: toDateString
        };
    }

    // ------------------
    // Data mapping
    // ------------------
    function getOverallTotal(data) {
        let overallTotal = 0;

        data.materials.forEach(function (material) {
            material.periods.forEach(function (period) {
                overallTotal += period._cumulative_inventory;
            });
        });
        return overallTotal;
    }

    function getTotalsPerPeriod(data) {
        let totals = [];
        data.materials.forEach(function (material) {
            // calculate totals for each date span
            material.periods.forEach(function (summary) {

                let key = summary.start_date + '-' + summary.end_date;
                let totalIndex = Array.indexByKey(totals, 'key', key);
                if (totalIndex === -1) {
                    totals.push({key: key, value: summary._cumulative_inventory});
                } else {
                    totals[totalIndex].value += summary._cumulative_inventory;
                }
            });
        });

        return totals;
    }

    // -------------
    //  Scope Fns
    // -------------
    $scope.getMonthName = function (dateString) {
        let date = moment(dateString, $scope.$root.dateFormat.moment);
        if (date.month() === 0 || date.month() === 11) {
            return date.format('MMMM YY');
        } else {
            return date.format('MMMM');
        }
    };

    $scope.getReportClass = function () {
        return $scope.reportOptions.type + '-report';
    };

    $scope.getReportTitle = function () {
        return {
            input: `Input Forecast Report`,
            output: `Output Forecast Report`,
            production: `Production Report`,
            production_output: "Inventory Forecast"
        }[$scope.reportOptions.type];
    };

    $scope.showTotalColumn = function () {
        return !$scope.showCurrentInventoryColumn();
    };

    $scope.showCurrentInventoryColumn = function () {
        return $scope.reportOptions.type === 'production_output';
    };

    $scope.changeCurrentInventory = function (material) {
        material.current_inventory_amount = material._current_inventory;

        material.system_color = material._system_color !== undefined ? material._system_color : '#FFF';

        MaterialSvc.update(material, $scope.data.plant).success(function (materialUpdated){
            material._current_inventory = materialUpdated.current_inventory_amount;
        });
        $scope.data.totalsPerPeriod = getTotalsPerPeriod($scope.data);
    };

    $scope.getCumulativeInventory = function (index, material, summary) {
        let cumulativeInventory = parseFloat(material.current_inventory_amount);
        if (isNaN(cumulativeInventory)) {
            cumulativeInventory = 0;
        }
        for (let i = index; i >= 0; i--) {
            material.periods[i].total.delta = material.periods[i].total.production_entries - material.periods[i].total.order_dates;
            cumulativeInventory += material.periods[i].total.delta;
        }

        summary._inventoryLow = checkAmount(material.min_inventory_amount) && (cumulativeInventory < material.min_inventory_amount);
        summary._inventoryHigh = checkAmount(material.max_inventory_amount) && (cumulativeInventory > material.max_inventory_amount);

        summary._cumulative_inventory = cumulativeInventory;

        return cumulativeInventory;
    };

    $scope.materialMaxMin = function (material) {
        if (checkAmount(material.max_inventory_amount) && checkAmount(material.min_inventory_amount)) {
            return String.format("Desired range: {0} - {1}", material.min_inventory_amount, material.max_inventory_amount);
        } else if (checkAmount(material.max_inventory_amount)) {
            return "Maximum inventory: " + material.max_inventory_amount;
        } else if (checkAmount(material.min_inventory_amount)) {
            return "Minimum inventory: " + material.min_inventory_amount;
        }
    };

    $scope.getTotalData = function () {

        switch ($scope.reportOptions.type) {
            case "input":
                return $scope.data.total.all;
            case "output":
                return $scope.data.total.all;
            case "production":
                return $scope.data.total;
            case "production_output":
                return getOverallTotal($scope.data);
            default:
                break;
        }
    };

    $scope.stringToDate = function (dateString) {
        return moment(dateString, $scope.$root.dateFormat.moment).toDate();
    };

    $scope.refreshData = function () {
        if (!$scope.reportOptions.from || !$scope.reportOptions.to || !$scope.reportOptions.resolution || !$scope.reportOptions.plant) {
            return;
        }

        let normalizedDateStrings = normalizeDates($scope.reportOptions.from, $scope.reportOptions.to);
        ForecastSvc.get($scope.reportOptions.plant,
            $scope.reportOptions.type,
            normalizedDateStrings.fromDate,
            normalizedDateStrings.toDate,
            $scope.reportOptions.resolution)
            .success(function (data) {
                $scope.data = data;
                $scope.data.materials.forEach(function (materialInScope) {
                    MaterialSvc.get(materialInScope.id, $scope.data.plant).success(function (material){
                        materialInScope._current_inventory = material.current_inventory_amount;
                        materialInScope._min_inventory = material.min_inventory_amount;
                        materialInScope._max_inventory = material.max_inventory_amount;
                    });
                });

                $timeout(function () {
                    // TODO The timeout is because the function is called from the template, instead we should bind
                    // to the value and then recalculate on changes
                    $scope.data.totalsPerPeriod = getTotalsPerPeriod(data);
                });
            });
    };

    $scope.getPrintButtonVisibility = function () {
        return ['output', 'input', 'production_output'].includes($scope.reportOptions.type);
    };

    $scope.getPrintReportUrl = function () {

        if (!$scope.reportOptions.from || !$scope.reportOptions.to) {
            return;
        }
       return ForecastSvc.getUrl($scope.reportOptions.plant,
            "production_output",
            $scope.reportOptions.from,
            $scope.reportOptions.to,
            $scope.reportOptions.resolution,
            "",
            "xlsx");
    };
    // ------------------
    // Watches
    // ------------------

    // ------------------
    // Initialization
    // ------------------
    let init = function (reportType) {

        // Test for valid report types
        if (['input', 'output', 'production', 'production_output'].indexOf(reportType) === -1) {
            throw "Unknown report";
        }

        $scope.form = {};
        $scope.data = {};

        $scope.urlWatcher = new UrlWatcherService(
            $scope,
            $scope.reportOptions,
            ['from', 'to', 'resolution'],
            {
                plant: $scope.plants[0].id.toString(),
                resolution: 'day',
                from: moment().day(0).startOf('day').format($scope.$root.dateFormat.moment_url),
                to: moment().day(5).startOf('day').format($scope.$root.dateFormat.moment_url)
            });

        $scope.urlWatcher.locationUpdated = function () {
            $scope.form.fromInput = moment(this.options.from, $scope.$root.dateFormat.moment_url).format($scope.$root.dateFormat.moment);
            $scope.form.toInput = moment(this.options.to, $scope.$root.dateFormat.moment_url).format($scope.$root.dateFormat.moment);
        };

        $scope.urlWatcher.optionsChanged = function () {
            $scope.refreshData();
        };

        // add a timeout to fake $locationChangeSuccess
        $timeout(function () {
            $scope.urlWatcher.extractReportOptionsFromLocation();
        });
    };
    init($scope.reportOptions.type);
}];
